export const getConfigsList = ({ configReducer: { configs = [] } = {} }) => configs;
export const getConfigFilters = ({ configReducer: { filter = {} } = {} }) =>
  filter;
export const getCount = ({ configReducer: { count = 0 } = {} }) => count;
